export const styles = () => ({
  placeholder: {
    textAlign: 'center'
  },

  container: {
    maxWidth: 1040,
    marginLeft: 'auto',
    marginRight: 'auto'
  },

  textCenter: {
    textAlign: 'center'
  },

  middleCell: {
    width: 500
  },

  timeInput: {
    width: 50,
  },

  title: {
    marginBottom: '0.55em'
  }
})



// WEBPACK FOOTER //
// ./src/components/RouteManagment/styles.js